import script from "./PetArchives.vue?vue&type=script&setup=true&lang=js"
export * from "./PetArchives.vue?vue&type=script&setup=true&lang=js"

import "./PetArchives.vue?vue&type=style&index=0&id=15df6aaa&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15df6aaa"]])

export default __exports__